import Logo from '../../objects/Logo';
import Menu from '../../objects/Menu';
import Sobre from '../../objects/Sobre';
import './styles.css';
import avatar from '../../images/squirrel.png';

type HeaderProps = {
	menuIsOpened?: Boolean
}

const Header = ({menuIsOpened = false}: HeaderProps) =>  {
	return (
		<header className='header'>
				<Logo avatar={avatar} caption={<span className='strong' lang='eo'>Logika</span>}/>
				<Sobre />
				<Menu opened={menuIsOpened}/>
		</header>
	);
}

export default Header;
	